export default __webpack_public_path__ + "static/manufacturing-header-c35ddd8b44abc80e4c097782d39f6a6c.jpg";